<template>
  <div class="letteritem" :class="{ 'isme': isMe }">
    <div class="pic" :style="{ backgroundImage: 'url(' + $setPicSize(item.portrait) + ')' }"></div>
    <div class="content">
      <div class="info-content-item" v-if="isTxt">{{ item.content }}</div>
      <div class="info-content-img" v-if="isImg">
        <img width="100" :src="$setPicSize(item.content, 200, 200)" />
      </div>
    </div>
  </div>
</template>

<script>
import { setPicSize } from '@zz-common/zz-utils'
export default {
  name: 'LetterItem',
  data() {
    return {
    }
  },
  props: ['item'],
  computed: {
    isTxt() {
      return this.item.type === '1'
    },
    isImg() {
      return this.item.type === '2'
    },
    isMe() {
      return this.item.isMe
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    }
  }
}
</script>

<style lang="less" scoped>
@import "index.less";
</style>